// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bd_s"};